import { render, staticRenderFns } from "./invoiceDialog.vue?vue&type=template&id=65b84b20&scoped=true"
import script from "./invoiceDialog.vue?vue&type=script&lang=js"
export * from "./invoiceDialog.vue?vue&type=script&lang=js"
import style0 from "./invoiceDialog.vue?vue&type=style&index=0&id=65b84b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b84b20",
  null
  
)

export default component.exports